













import {Component, Prop, Vue} from 'vue-property-decorator';
import BoxTile from '@/components/ui/BoxTile.vue';
import TextContent from '@/components/ui/TextContent.vue';

@Component({
  components: {
    TextContent,
    BoxTile
  },
})
export default class GoalsQuestions extends Vue {

  @Prop()
  public id!: string;

  get goalDetails() {
    return this.$store.getters.goalDetailById(this.id);
  }

  get language() {
    if (this.$store.state.lang === 'es')
      return 'lang2';
    return 'lang1';
  }

  get questions() {
    if (this.goalDetails &&
            this.goalDetails.details &&
            this.goalDetails.details.promptGoalCards &&
            this.goalDetails.details.promptGoalCards.length) {
      return this.goalDetails.details.promptGoalCards;
    }
    return [];
  }

}
